import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuVisibilityService {
  mobileMenuIsOpen: boolean = false;
  constructor() { }
  public isNavOpened() {
    return this.mobileMenuIsOpen;
  }

  public toggleNavVisibility() {
    this.mobileMenuIsOpen = !this.mobileMenuIsOpen;
  }

  public closeNavigation() {
    this.mobileMenuIsOpen = false;
  }

  public openNavigation() {
      this.mobileMenuIsOpen = true;
  }
}
